import { CustomerType, ExtraInformationStatusType, Profile } from '@/pages/Profile/Profile.types';

export interface ProfileCompletionOptions {
  profile: Partial<Profile>;
  profileExtraInformationStatus?: ExtraInformationStatusType;
}

/**
 * Check if profile is completed with all required fields
 * @param options - Profile data and extra information status
 * @returns true if profile is completed, false otherwise
 */
export function isProfileCompleted(options: ProfileCompletionOptions): boolean {
  const { profile, profileExtraInformationStatus } = options;

  if (!profile) return false;

  // Always required fields
  if (!profile.userName) return false;
  if (!profile.nickName) return false;
  if (!profile.mobileNumber) return false;

  // Check if profile is locked
  const isLocked =
    profileExtraInformationStatus !== undefined &&
    ![ExtraInformationStatusType.Trial, ExtraInformationStatusType.Changeable].includes(profileExtraInformationStatus);

  // Required when profile is not locked
  if (!isLocked) {
    if (!profile.firstName) return false;
    if (!profile.lastName) return false;
    if (!profile.postalCode) return false;
    if (!profile.customerType) return false;

    // Natural person (individual) requirements
    if (profile.customerType === CustomerType.Natural) {
      if (!profile.nationalCode) return false;

      // Economic code required only if checkbox is checked
      if (profile.haveEconomicCode && !profile.economicCode) return false;
    }

    // Legal person (business) requirements
    if (profile.customerType === CustomerType.Legal) {
      if (!profile.companyName) return false;
      if (!profile.nationalId) return false;
      if (!profile.registrationNumber) return false;
    }
  }

  // Activity category title required when category is "Other" (9)
  if (profile.activityCategory === 9 && !profile.activityCategoryTitle) return false;

  return true;
}
